/* External */
import {
  call, put, takeLatest,
} from 'redux-saga/effects';

/* Utils */
import { getPagesVersionActive } from '../../utils/functions';

/* ActionTypes */
import { FETCH_PAGE_BY_ID } from './actionTypes';

/* Actions */
import { addToEntities } from '../utils/actions';

/* Sagas */
import { requestSaga } from '../requests/sagas';
import { authenticatedSaga } from '../utils/sagas';

/* Services */
import backendService from '../../services/backendService';

function fetchPageByIdService({ pageId, sportIds }) {
  const pagesVersionActive = getPagesVersionActive();

  return backendService.layout[pagesVersionActive].getPage(pageId, sportIds);
}

function* fetchPageByIdSaga(action) {
  try {
    const response = yield call(requestSaga, fetchPageByIdService, action);
    if (response) {
      const { normalizedData: { entities } } = response;

      yield put(addToEntities(entities));
    }
  } catch (error) {
    console.error('pages>fetchPageByIdSaga', error);
  }
}

export function* fetchPageById() {
  yield takeLatest(FETCH_PAGE_BY_ID, authenticatedSaga(fetchPageByIdSaga));
}

export default [
  fetchPageById,
];
